import { render, staticRenderFns } from "./NavBook.vue?vue&type=template&id=47dfbdce&scoped=true&"
import script from "./NavBook.vue?vue&type=script&lang=js&"
export * from "./NavBook.vue?vue&type=script&lang=js&"
import style0 from "./NavBook.vue?vue&type=style&index=0&id=47dfbdce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dfbdce",
  null
  
)

export default component.exports